import { useAuth } from "@/context/AuthContext";
import AdminOnboarding from "./onboarding/AdminOnboarding";
import StaffOnboarding from "./onboarding/StaffOnboarding";

export default function Onboarding() {
  const { user } = useAuth();
  return user.role === "staff" ? <StaffOnboarding /> : <AdminOnboarding />;
}
